import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/contact'

const Contact: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UX/UI 生成AI クラウドネイティブ DevOps モダンアプリケーション開発'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/contact/'}
        title="お問い合わせ | Aitria（アイトリア）"
        description="デジタルイノベーションパートナーとして、最適な課題解決方法をご提案いたします。ブランディング戦略、事業戦略、マーケティング、DX支援、UX/UIデザインなどお気軽にご相談ください。"
      />
      <Template />
    </>
  )
}

export default Contact
